<div class="row" *ngIf="isComercial">
  <div class="col-md col-xs col-xl col-sm wd-100-pc">
    <mat-card class="mat-elevation-z8 wd-100-pc">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Utilizado Medidor de Vazão</mat-label>
                <mat-select (selectionChange)="disableFields($event)" formControlName="medidor_vazao"
                  disableCenteringOption>
                  <input type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterMedidorVazao($event.target.value)">
                  <mat-option *ngFor="let item of listMedidor" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.repasse_color_sendo_descartado)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Repasse da Color sendo Descartado</mat-label>
                <mat-select #txtRepColDesc formControlName="repasse_color_sendo_descartado" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterRepasseColorSendoDescartado($event.target.value)">
                  <mat-option *ngFor="let item of listRepasseColorSendoDescartado" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.repasse_color_sendo_descartado)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso (g) Semente Boa 10 Segundos (Color Sorter)
                </mat-label>
                <input matInput id="txtPesoSemBDez" #txtPesoSemBDez maxlength="9"
                  formControlName="peso_g_semente_boa_dez_segundos" currencyMask
                  (blur)="makeCalculations(); mkCalcII(); verificarVazaoSementeBoa();" [readonly]="disableField"
                  [class.InputBlockColor]="disableField">
                <i matSuffix class="{{iconEnableField}}"></i>
                <i matSuffix *ngIf="disableField === true" class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                </mat-hint>
                <mat-hint align="end">{{txtPesoSemBDez.value.length}} / 9</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_g_semente_boa_dez_segundos)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso (g) Descarte 10 Segundos (Coluna de Ar)
                </mat-label>
                <input matInput id="txtPesoDescDezSegAr" #txtPesoDescDezSegAr maxlength="6"
                  formControlName="peso_g_descarte_dez_segundos_coluna_ar" currencyMask
                  (blur)="makeCalculations(); mkCalcII();">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                </mat-hint>
                <mat-hint align="end">{{txtPesoDescDezSegAr.value.length}} / 6</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.peso_g_descarte_dez_segundos_coluna_ar)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso (g) Descarte 10 Segundos (Color Sorter)
                </mat-label>
                <input matInput id="txtPesoDescDezSegSorter" #txtPesoDescDezSegSorter maxlength="9"
                  formControlName="peso_g_descarte_dez_segundos_color_sorter" currencyMask
                  (blur)="makeCalculations(); mkCalcII(); verificarVazaoSementeBoa()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                </mat-hint>
                <mat-hint align="end">{{txtPesoDescDezSegSorter.value.length}} / 9</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.peso_g_descarte_dez_segundos_color_sorter)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso (g) Descarte 10 Segundos (Densimétrica)
                </mat-label>
                <input matInput id="txtPesoDescDezSegDensi" #txtPesoDescDezSegDensi maxlength="9"
                  formControlName="peso_g_descarte_dez_segundos_densimetrica" currencyMask
                  (blur)="makeCalculations(); mkCalcII();">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                </mat-hint>
                <mat-hint align="end">{{txtPesoDescDezSegDensi.value.length}} / 9</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.peso_g_descarte_dez_segundos_densimetrica)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-md btn-and-info">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Vazão de semente boa Color Sorter/Densimétrica (ton/h)</mat-label>
                <input matInput id="txtVazaoSemBoaSorter" (blur)="verificarVazaoSementeBoa()" #txtVazaoSemBoaSorter
                  maxlength="5" formControlName="vazao_semente_boa_color_sorter_ton_h"
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" currencyMask
                  [readonly]="!isPTU && !disableField" [class.InputBlockColor]="!isPTU && !disableField">
                <i matSuffix class="{{iconDisableField}}" *ngIf="!isPTU && !disableField"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isPTU && disableField"></i>
                <mat-hint align="start" class="InputLabelDetailsColor" *ngIf="!isPTU && !disableField">
                  {{hintCalc}}</mat-hint>
                <mat-hint align="start" class="InputLabelDetailsColor" *ngIf="!isPTU && disableField">
                  {{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtVazaoSemBoaSorter.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.vazao_semente_boa_color_sorter_ton_h)}}</mat-error>
              </mat-form-field>
              <button mat-flat-button color="primary" *ngIf="disabledFields" class="btnSize btn-edit"
                matTooltip="Editar" (click)="makeEditBtn()" [hidden]="hiddenButtonEditar">
                <i class="fa fa-edit fa-1x btnIcon"></i> Editar
              </button>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Vazão de Descarte Coluna de Ar (Kg/h)
                </mat-label>
                <input matInput id="txtVazaoDescColAr" #txtVazaoDescColAr maxlength="10"
                  formControlName="vazao_descarte_coluna_ar_kg_h" currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtVazaoDescColAr.value.length}} / 10</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.vazao_descarte_coluna_ar_kg_h)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Vazão de Descarte Color Sorter (Kg/h)
                </mat-label>
                <input matInput id="txtVazaoDescColSorter" #txtVazaoDescColSorter maxlength="10"
                  formControlName="vazao_descarte_color_sorter_kg_h" currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtVazaoDescColSorter.value.length}} / 10</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.vazao_descarte_color_sorter_kg_h)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Vazão de Descarte Densimétrica (Kg/h)
                </mat-label>
                <input matInput id="txtVazaoDescDensi" #txtVazaoDescDensi maxlength="10"
                  formControlName="vazao_descarte_densimetrica_kg_h" currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtVazaoDescDensi.value.length}} / 10</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.vazao_descarte_densimetrica_kg_h)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>

<div class="row" *ngIf="isBasica">
  <div class="col-md col-xs col-xl col-sm wd-100-pc">
    <mat-card class="mat-elevation-z8 wd-100-pc">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">
          <div class="row pt-3">
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso (g) Semente Boa 5 Segundos (Color Sorter)
                </mat-label>
                <input matInput id="txtPesoSemBDez" #txtPesoSemBDez maxlength="10"
                  formControlName="peso_g_semente_boa_cinco_segundos" currencyMask
                  (blur)="makeCalculations(); mkCalcIII()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                </mat-hint>
                <mat-hint align="end">{{txtPesoSemBDez.value.length}} / 10</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.peso_g_semente_boa_cinco_segundos)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso (g) descarte 60 segundos (color sorter)
                </mat-label>
                <input matInput id="txtPesoDescDezSegSorter" #txtPesoDescDezSegSorter maxlength="9"
                  formControlName="peso_g_descarte_sessenta_segundos_color_sorter" currencyMask
                  (blur)="makeCalculations(); mkCalcIII()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                </mat-hint>
                <mat-hint align="end">{{txtPesoDescDezSegSorter.value.length}} / 9</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.peso_g_descarte_sessenta_segundos_color_sorter)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso (g) descarte 60 segundos (coluna de ar) - 1
                </mat-label>
                <input matInput id="txtPesoDescDezSegAr" #txtPesoDescDezSegAr maxlength="10"
                  formControlName="peso_g_descarte_sessenta_segundos_coluna_ar" currencyMask
                  (blur)="makeCalculations(); mkCalcIII()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                </mat-hint>
                <mat-hint align="end">{{txtPesoDescDezSegAr.value.length}} / 10</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.peso_g_descarte_sessenta_segundos_coluna_ar)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso (g) descarte 60 segundos (coluna de ar) - 2
                </mat-label>
                <input matInput id="txtPesoDescSessentaSegAr2" #txtPesoDescSessentaSegAr2 maxlength="10"
                  formControlName="peso_g_descarte_sessenta_segundos_coluna_ar2" currencyMask
                  (blur)="makeCalculations(); mkCalcIII()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                </mat-hint>
                <mat-hint align="end">{{txtPesoDescSessentaSegAr2.value.length}} / 10</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.peso_g_descarte_sessenta_segundos_coluna_ar2)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Vazão de semente boa Color Sorter/Dessimétrica (ton/h)
                </mat-label>
                <input matInput id="txtVazaoSemBoaSorter" #txtVazaoSemBoaSorter maxlength="9"
                  formControlName="vazao_semente_boa_color_sorter_ton_h" currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtVazaoSemBoaSorter.value.length}} / 9</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.vazao_semente_boa_color_sorter_ton_h)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Vazão de Descarte Color Sorter (Kg/h)
                </mat-label>
                <input matInput id="txtVazaoDescColSorter" #txtVazaoDescColSorter maxlength="10"
                  formControlName="vazao_descarte_color_sorter_kg_h" currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtVazaoDescColSorter.value.length}} / 10</mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.vazao_descarte_color_sorter_kg_h)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>